import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
// import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
// import MenuIcon from '@mui/icons-material/Menu';
import EmailIcon from '@mui/icons-material/Email';
import InstaIcon from '@mui/icons-material/Instagram';
import DirectionsIcon from '@mui/icons-material/Directions';
import { Button } from '@mui/material';

import { useAppContext } from '../../context/AppContext';
// import Button from '../Button';

export default function Header() {
  const btnTextColor = '#00FFFF';
  const { onEmailClick, onInstaClick, onDirectionsClick, onBookClick } = useAppContext();
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="fixed" sx={{ backgroundColor: '#abb8c3', color: 'black' }}>
        <Toolbar>
          <div style={{ flexGrow: 1 }}>
            <Button
              sharp
              color="primary"
              variant="contained"
              onClick={onBookClick}
              style={{ backgroundColor: btnTextColor }}
            >
              Book with Me
            </Button>
          </div>
          <IconButton onClick={onInstaClick} style={{ color: btnTextColor }}>
            <InstaIcon />
          </IconButton>
          <IconButton onClick={onEmailClick} style={{ color: btnTextColor }}>
            <EmailIcon />
          </IconButton>
          <IconButton onClick={onDirectionsClick} style={{ color: btnTextColor }}>
            <DirectionsIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
